export const constants = {
	selector: {
		target: 'data-datetime',
		locale: 'data-datetime-locale',
	},
}
